<template>
  <div class="container">
    <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多啦"
        @load="load_more"
      >
    <div class="flex" v-for="item in list" :key="item.id" @click="urlchange(item.id)">
      <div>
        <p class="left">{{item.content}}</p>
        <p style="font-size:12px;color:grey;margin-top:5px;">{{timeTrans(item.createtime)}}</p>
      </div>
      <p class="right">{{item.isread}}</p>
    </div>
    </van-list>
  </div>
</template>
<script>
export default {
  name:'mail',
  data() {
    return {
      list:[],
      loading:false,
      finished:false,
      page: 1,
    }
  },
  created(){
    this.$axios({
      method:'post',
      url:'/api/home/zhannei_list',
      data:this.qs.stringify({
        token:sessionStorage.getItem('wmtoken'),
      })
    }).then(res => {
      console.log(res.data);
      if(res.data.code == 0){
        this.list = res.data.data.list;
        for(let i in this.list){
          switch(this.list[i].isread){
            case 0:
              this.list[i].isread = '未读';
              break;
            case 1:
              this.list[i].isread = '已读';
              break;
            default:
              break;
          }
        }
      }else{
        this.$toast(res.data.msg);
      }
    })
  },
  methods:{
    urlchange(id){
      this.$router.push({
        name:'maildetail',
        query:{
          id:id,
        }
      })
    },
    load_more(){
      this.page += 1;
      var that = this;
      setTimeout(function(){
        that.$axios({
          method:'post',
          url:'/api/home/zhannei_list',
          data:that.qs.stringify({
            token:sessionStorage.getItem('wmtoken'),
            page:that.page,
          })
        }).then(res => {
          console.log(res.data);
          if(res.data.code == 0){
            for(let i in res.data.data.list){
              switch(res.data.data.list[i].isread){
                case 0:
                  res.data.data.list[i].isread = '未读';
                  break;
                case 1:
                  res.data.data.list[i].isread = '已读';
                  break;
                default:
                  break;
              }
            }
            that.list = that.list.concat(res.data.data.list);
          }
          that.loading = false;
          if (res.data.data.list.length == 0) {  //数据全部加载完成
            that.finished = true;
          }else{
            that.finished = false;
          }
        })
      },500)
      
    },
  }
}
</script>
<style scoped>
.container{
  padding: 10px;
}
.flex{
  padding: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.left{
  width: 100%;
  display:-webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-all;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.right{
  width: 25%;
  margin-left: 10px;
  white-space: nowrap;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/mail.vue